export const BLOCK_TELEMETRY_COOKIE_NAME = 'block_tracking'
export const BLOCK_TELEMETRY_COOKIE_VALUE = {
  BLOCK_PIXEL: 'block-pixel',
  BLOCK_IA: 'block-ia',
  BLOCK_STATSIG: 'block-statsig',
}
